<template>
  <!-- BEGIN: Content-->
  <div>
    <hr>
    <h4>Distribution by year</h4>
    <p>Automatic (distributes {{ grant.type.type === 'monetary' ? 'equally the amount given' : 'the amount given to your group/research unit' }} ) or manual (you must enter the values)</p>
    <div class="mb-2">
      <a
        class="btn btn-primary"
        @click="autoMode"
      ><i data-feather="cpu" /> Click here to evenly distribute amounts</a>
      <!-- <a
        href=""
        class="btn btn-primary ms-25"
      ><i data-feather="edit-2" /> Manual</a> -->
    </div>
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>Year</th>
          <th>Amount</th>
          <th>Days</th>
          <th />
          <th />
          <th class="text-end" />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="year, index in years"
          :key="year.year"
        >
          <td>{{ year.year }}</td>
          <td>
            <div class="input-group">
              <input
                v-model="year.amount"
                type="text"
                step="0.01"
                class="form-control"
                placeholder="0,00"
                aria-label="0,00"
                aria-describedby="basic-addon2"
                value="10.000,00"
                @change="updateYear(year)"
              >
              <span
                id="basic-addon2"
                class="input-group-text"
              >€</span>
            </div>
          </td>
          <td>
            <div
              class="input-group"
              :class="index == 0 || index == (years.length - 1) ? 'disabled' : ''"
            >
              <span
                id="basic-addon2"
                class="input-group-text"
              >From</span>
              <date-picker
                v-model="year.from"
                format="D MMM YYYY"
                value-type="format"
                :disabled="year.all_year || index == 0 || index == (years.length - 1)"
                class="custom-disabled"
                @change="updateYear(year)"
              />
            </div>
          </td>
          <td>
            <div
              class="input-group"
              :class="index == 0 || index == (years.length - 1) ? 'disabled' : ''"
            >
              <span
                id="basic-addon2"
                class="input-group-text"
              >To</span>
              <date-picker
                v-model="year.to"
                format="D MMM YYYY"
                value-type="format"
                :disabled="year.all_year || index == 0 || index == (years.length - 1)"
                class="custom-disabled"
                @change="updateYear(year)"
              />
            </div>
          </td>
          <td>
            <div class="form-check">
              <input
                id="inlineCheckbox1"
                v-model="year.all_year"
                class="form-check-input"
                type="checkbox"
                value="checked"
                :disabled="index == 0 || index == (years.length - 1)"
                @change="updateYear(year)"
              >
              <label
                class="form-check-label"
                for="inlineCheckbox1"
              >All year</label>
            </div>
          </td>
          <td>
            {{ year.days }} days <span v-if="year.amount">({{ (parseFloat((typeof year.amount === 'string' ? year.amount.replaceAll(',', '') : year.amount)) / year.days).toFixed(4) }}€ x day)</span>
          </td>
        </tr>

        <tr
          v-if="grant.total_amount_group"
          :class="totalAmount == parseFloat(typeof grant.total_amount_group === 'string' ? grant.total_amount_group.replaceAll(',', '') : grant.total_amount_group) ? 'table-success' : 'table-danger'"
        >
          <td><strong>TOTAL</strong></td>
          <td>
            <strong :class="totalAmount == parseFloat(typeof grant.total_amount_group === 'string' ? grant.total_amount_group.replaceAll(',', '') : grant.total_amount_group) ? 'text-success' : 'text-danger'">
              {{ totalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} €
            </strong>
            <span
              v-if="totalAmount != parseFloat(typeof grant.total_amount_group === 'string' ? grant.total_amount_group.replaceAll(',', '') : grant.total_amount_group)"
              class="text-danger ms-2"
            >Incorrect total, expected {{ grant.total_amount_group }}€</span>
          </td>
          <td />
          <td />
          <td />
          <td />
        </tr>
        <tr
          v-if="(grant.type.type === 'monetary' && grant.total_amount)"
          :class="parseFloat(totalAmount) == parseFloat(typeof grant.total_amount === 'string' ? grant.total_amount.replaceAll(',', '') : grant.total_amount) ? 'table-success' : 'table-danger'"
        >
          <td><strong>TOTAL</strong></td>
          <td>
            <strong :class="parseFloat(totalAmount) == parseFloat(typeof grant.total_amount === 'string' ? grant.total_amount.replaceAll(',', '') : grant.total_amount) ? 'text-success' : 'text-danger'">{{ totalAmount }} €</strong>
            <span
              v-if="parseFloat(totalAmount) != parseFloat(typeof grant.total_amount === 'string' ? grant.total_amount.replaceAll(',', '') : grant.total_amount)"
              class="text-danger ms-2"
            >Incorrect total, expected {{ grant.total_amount }}€</span>
          </td>
          <td />
          <td />
          <td />
          <td />
        </tr>
      </tbody>
    </table>
  </div>
  <!-- END: Content-->
</template>

<script>
import { mapGetters } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      grant: 'grants/item',
    }),
    totalAmount() {
      const visibleYears = this.generateYearsBetween()
      const visibleAmounts = this.grant.amounts.filter(item => visibleYears.includes(Number(item.year)))

      if (visibleAmounts.length === 0) {
        return 0
      }
      const sum = visibleAmounts.reduce((total, item) => total + this.parseAmount(item.amount), 0)
      return parseFloat(sum.toFixed(2))
    },
    years() {
      const data = []
      const years = this.generateYearsBetween()
      years.forEach((year, index) => {
        if (years.length === 1) {
          data[year] = this.grant.amounts[this.grant.amounts.findIndex(x => x.year === year)] ?? {
            year,
            from: this.grant.begin_date,
            to: this.grant.end_date,
            days: this.getDaysMoney(this.grant.begin_date, this.grant.end_date),
          }
        } else if (index === years.length - 1) {
          data[year] = this.grant.amounts[this.grant.amounts.findIndex(x => x.year === year)] ?? {
            year,
            from: this.getYearStart(year),
            to: this.grant.end_date,
            days: this.getDaysMoney(this.getYearStart(year), this.grant.end_date),
          }
        } else if (index === 0) {
          data[year] = this.grant.amounts[this.grant.amounts.findIndex(x => x.year === year)] ?? {
            year,
            from: this.grant.begin_date,
            to: this.getYearEnd(year),
            days: this.getDaysMoney(this.grant.begin_date, this.getYearEnd(year)),
          }
        } else {
          data[year] = this.grant.amounts[this.grant.amounts.findIndex(x => x.year === year)] ?? {
            year,
            all_year: true,
            from: this.getYearStart(year),
            to: this.getYearEnd(year),
            days: this.getDaysMoney(this.getYearStart(year), this.getYearEnd(year)),
          }
        }

        if (this.grant.amounts[this.grant.amounts.findIndex(x => x.year === year)] === undefined) {
          this.grant.amounts.push(data[year])
        }
      })

      return data.filter(e => e !== undefined)
    },
  },
  watch: {
    'grant.begin_date': 'syncAmountsWithPeriod',
    'grant.end_date': 'syncAmountsWithPeriod',
  },
  async mounted() {
    this.syncAmountsWithPeriod()

    if (this.grant.amounts) {
      this.grant.amounts.forEach((e, index) => {
        this.formatFloat(e.amount, index)
      })
    }

    setTimeout(() => {
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 500)
  },
  methods: {
    syncAmountsWithPeriod() {
      if (!this.grant.begin_date || !this.grant.end_date) {
        return false
      }

      const beginDate = new Date(this.grant.begin_date)
      const endDate = new Date(this.grant.end_date)
      if (Number.isNaN(beginDate.getTime()) || Number.isNaN(endDate.getTime()) || beginDate > endDate) {
        return false
      }

      const validYears = this.generateYearsBetween()
      const validAmounts = validYears.map((year, index) => {
        const amount = this.grant.amounts.find(item => Number(item.year) === year) || { year }

        if (validYears.length === 1) {
          amount.from = this.grant.begin_date
          amount.to = this.grant.end_date
        } else if (index === 0) {
          amount.from = this.grant.begin_date
          amount.to = this.getYearEnd(year)
        } else if (index === validYears.length - 1) {
          amount.from = this.getYearStart(year)
          amount.to = this.grant.end_date
        } else {
          amount.from = this.getYearStart(year)
          amount.to = this.getYearEnd(year)
        }

        amount.all_year = this.isFullYear(year, amount.from, amount.to)
        amount.days = this.getDaysMoney(amount.from, amount.to)
        return amount
      })

      this.grant.amounts.splice(0, this.grant.amounts.length, ...validAmounts)
      return true
    },
    generateYearsBetween() {
      let year = new Date(this.grant.begin_date).getFullYear()
      const endYear = new Date(this.grant.end_date).getFullYear()
      const years = []

      for (let i = year; i <= endYear; i++) {
        years.push(year)
        year++
      }
      return years
    },
    updateYear(item) {
      const data = item

      if (data.all_year) {
        data.from = this.getYearStart(data.year)
        data.to = this.getYearEnd(data.year)
      }

      data.days = this.getDaysMoney(item.from, item.to)

      const amountIndex = this.grant.amounts.findIndex(amount => Number(amount.year) === Number(data.year))
      if (amountIndex >= 0) {
        this.grant.amounts.splice(amountIndex, 1, data)
      } else {
        this.grant.amounts.push(data)
      }

      this.formatFloat(item.amount, amountIndex >= 0 ? amountIndex : this.grant.amounts.length - 1)

      this.$forceUpdate()
    },
    formatFloat(float, index) {
      if (float) {
        let str = float.toString().trim()
        const lastComma = str.lastIndexOf(',')
        const lastDot = str.lastIndexOf('.')
        if (lastComma > lastDot) {
          // Comma is last separator — treat as decimal if ≤2 digits follow it, else thousands
          if (str.slice(lastComma + 1).length <= 2) {
            str = str.replaceAll('.', '').replace(',', '.')
          } else {
            str = str.replaceAll(',', '')
          }
        }
        const value = str.replace(/[^\d.]/g, '')
        const parts = value.split('.')

        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

        this.grant.amounts[index].amount = parts.join('.')
      }
    },
    parseAmount(amount) {
      if (!amount) {
        return 0
      }

      return parseFloat(typeof amount === 'string' ? amount.replaceAll(',', '') : amount) || 0
    },
    getYearStart(year) {
      return `1 Jan ${year}`
    },
    getYearEnd(year) {
      return `31 Dec ${year}`
    },
    isFullYear(year, from, to) {
      const fromDate = new Date(from)
      const toDate = new Date(to)
      return fromDate.getFullYear() === year
        && fromDate.getMonth() === 0
        && fromDate.getDate() === 1
        && toDate.getFullYear() === year
        && toDate.getMonth() === 11
        && toDate.getDate() === 31
    },
    autoMode() {
      const target = this.grant.type.type === 'monetary' ? this.grant.total_amount : this.grant.total_amount_group
      const totalDays = this.grant.amounts.reduce((total, item) => total + (Number(item.days) || 0), 0)
      if (target === null || target === undefined || target === '' || !totalDays || this.grant.amounts.length === 0) {
        return
      }

      const targetAmount = this.parseAmount(target)
      let cumulativeDays = 0
      let previousCumulativeAmount = 0
      this.grant.amounts.forEach((item, index) => {
        cumulativeDays += item.days
        const cumulativeAmount = Math.round(((cumulativeDays * targetAmount) / totalDays) * 100) / 100
        const amount = cumulativeAmount - previousCumulativeAmount
        previousCumulativeAmount = cumulativeAmount

        item.amount = amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.grant.amounts.splice(index, 1, item)
      })
      this.$forceUpdate()
    },
    getDaysMoney(from, to) {
      const date1 = new Date(from)
      const date2 = new Date(to)
      const difference = date2.getTime() - date1.getTime()
      return Math.ceil(difference / (1000 * 3600 * 24)) + 1
    },
  },

}
</script>
